// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2soGp","footer":"styles_footer__FOYfk","passCodeTooltip":"styles_passCodeTooltip__2nwb-"};